import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Grid, TextField, Typography, Button, Autocomplete, MenuItem,
  Stepper, Step, StepLabel, Divider, IconButton,
} from '@mui/material';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Detalle from './ReporteServicios/Detalle';
import { maintenanceDataPorTipo } from '../components/utils/maintenanceData';
import api from '../components/utils/api';
import swal from "sweetalert";
import Loading from "../components/Loading/Loading";

const STEPS = ["Equipo", "Datos tecnicos", "Condiciones", "Cierre"];

const REPORTES = [
  { label: "MOTONIVELADORA",        value: 1  },
  { label: "MINICARGADOR",          value: 2  },
  { label: "PALACARGADORA",         value: 3  },
  { label: "PALA-RETRO",            value: 4  },
  { label: "EXCAVADORA HIDRAULICA", value: 5  },
  { label: "HIDROGRUA",             value: 6  },
  { label: "TRACTOR",               value: 7  },
  { label: "RODILLO",               value: 8  },
  { label: "CAMION FUERA DE RUTA",  value: 9  },
  { label: "AUTOELEVADORES",        value: 10 },
  { label: "GENERADOR",             value: 11 },
  { label: "GRUA",                  value: 12 },
  { label: "TOPADOR",               value: 13 },
  { label: "BOMBA DE HORMIGON",     value: 14 },
];

function playSuccess() {
  try {
    const ctx  = new (window.AudioContext || window.webkitAudioContext)();
    const play = (freq, start, dur) => {
      const osc  = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.25, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + dur);
    };
    play(523, 0,    0.15);
    play(659, 0.15, 0.15);
    play(784, 0.30, 0.25);
  } catch (e) {}
}

function StepIconCustom({ active, completed, icon }) {
  if (completed) return <CheckCircleIcon sx={{ color: "#2E7D32", fontSize: 28 }} />;
  return (
    <Box sx={{
      width: 28, height: 28, borderRadius: "50%", display: "flex",
      alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 13,
      bgcolor: active ? "#ED9519" : "action.disabledBackground",
      color: active ? "#1a0e00" : "text.disabled",
    }}>
      {icon}
    </Box>
  );
}

const NuevoReporteServicio = ({ mode = "create", initialData = {}, onClose }) => {
  const userToken = localStorage.getItem("user-token");
  const user      = localStorage.getItem("nombre-Completo");
  const navigate  = useNavigate();

  const [paso, setPaso]       = useState(0);
  const [loading, setLoading] = useState(false);

  const [tipoReporte,    setTipoReporte]    = useState(initialData.tipoReporte || null);
  const [reporteElegido, setReporteElegido] = useState(initialData.tipoReporte || null);
  const [cliente,        setCliente]        = useState(initialData.cliente     || "");
  const [ubicacion,      setUbicacion]      = useState(initialData.ubicacion   || "");

  const [datos, setDatos] = useState({
    modelo:       initialData.modelo       || "",
    chasis:       initialData.chasis       || "",
    serie:        initialData.serie        || "",
    modeloMotor:  initialData.modeloMotor  || "",
    serieMotor:   initialData.serieMotor   || "",
    modeloMotor1: initialData.modeloMotor1 || "",
    serieMotor1:  initialData.serieMotor1  || "",
    horometro:    initialData.horometro    || "",
    fecha:        initialData.fecha        || new Date().toISOString().split("T")[0],
  });
  const [transmision, setTransmision] = useState(initialData.tipoTransmision || "");

  const handleDatosChange = useCallback(e => {
    const { id, value } = e.target;
    setDatos(prev => ({ ...prev, [id]: value }));
  }, []);

  const [selectedCondition,   setSelectedCondition]   = useState(initialData.tipo || "");
  const [condicionesServicio, setCondicionesServicio] = useState(initialData.condicionesPorServicios || []);
  const [detalleData,         setDetalleData]         = useState(initialData.condicionesPorServicios || []);

  const handleAutoComplete = useCallback((_, newValue) => {
    if (newValue) {
      const tipo = newValue.label;
      const data = maintenanceDataPorTipo[tipo] || [];
      setTipoReporte(tipo);
      setReporteElegido(tipo);
      setCondicionesServicio(data);
      setDetalleData(data);
    } else {
      setTipoReporte(null);
      setReporteElegido(null);
      setCondicionesServicio([]);
      setDetalleData([]);
    }
  }, []);

  const handleConditionChange = useCallback((id, newCond) => {
    setDetalleData(prev =>
      prev.map(item => item.id === id ? { ...item, condicion: newCond, updatedAt: new Date().toISOString() } : item)
    );
    setCondicionesServicio(prev =>
      prev.map(item => item.id === id ? { ...item, condicion: newCond } : item)
    );
  }, []);

  const [cierre, setCierre] = useState({
    firmaI:      initialData.firmaI              || user || "",
    aclaracionI: initialData.aclaracionInspector || user || "",
    firmaC:      initialData.firmaCliente        || "",
    aclaracionC: initialData.aclaracionCliente   || "",
    comnetarioI: initialData.comentarioInspector || "",
    comnetarioC: initialData.comentarioCliente   || "",
  });

  const handleCierre = useCallback((field, value) => {
    setCierre(prev => ({ ...prev, [field]: value }));
  }, []);

  const validarPaso = () => {
    if (paso === 0) {
      if (!tipoReporte) { swal("Error", "Selecciona el tipo de equipo", "error"); return false; }
      if (!cliente)     { swal("Error", "El cliente es requerido", "error"); return false; }
      if (!ubicacion)   { swal("Error", "La ubicacion es requerida", "error"); return false; }
    }
    if (paso === 1) {
      if (!datos.serie)     { swal("Error", "El N de serie es requerido", "error"); return false; }
      if (!datos.horometro) { swal("Error", "El horometro es requerido", "error"); return false; }
      if (!transmision)     { swal("Error", "Selecciona el tipo de transmision", "error"); return false; }
    }
    if (paso === 2) {
      if (!selectedCondition) { swal("Error", "Selecciona una condicion de servicio", "error"); return false; }
    }
    if (paso === 3 && selectedCondition !== "P") {
      if (!cierre.firmaC)      { swal("Error", "La firma del cliente es requerida", "error"); return false; }
      if (!cierre.aclaracionC) { swal("Error", "La aclaracion del cliente es requerida", "error"); return false; }
    }
    return true;
  };

  const validarTodo = () => {
    if (!tipoReporte)         { swal("Error", "Selecciona el tipo de equipo", "error"); return false; }
    if (!cliente)             { swal("Error", "El cliente es requerido", "error"); return false; }
    if (!ubicacion)           { swal("Error", "La ubicacion es requerida", "error"); return false; }
    if (!datos.serie)         { swal("Error", "El N de serie es requerido", "error"); return false; }
    if (!datos.horometro)     { swal("Error", "El horometro es requerido", "error"); return false; }
    if (!transmision)         { swal("Error", "Selecciona el tipo de transmision", "error"); return false; }
    if (!selectedCondition)   { swal("Error", "Selecciona una condicion de servicio", "error"); return false; }
    if (selectedCondition !== "P") {
      if (!cierre.firmaC)      { swal("Error", "La firma del cliente es requerida", "error"); return false; }
      if (!cierre.aclaracionC) { swal("Error", "La aclaracion del cliente es requerida", "error"); return false; }
    }
    return true;
  };

  const avanzar    = () => { if (validarPaso()) setPaso(p => p + 1); };
  const retroceder = () => setPaso(p => p - 1);

  const enviar = async () => {
    if (mode === "edit" ? !validarTodo() : !validarPaso()) return;
    const ok = await swal({
      title: "Confirmar envio?",
      text: "Verifica los datos antes de continuar.",
      icon: "warning", buttons: true, dangerMode: true,
    });
    if (!ok) return;

    const body = {
      ...datos,
      tipo:                selectedCondition,
      tipoTransmision:     transmision,
      cliente,
      ubicacion,
      usuario:             user,
      tipoReporte,
      reporteElegido,
      data:                detalleData,
      comentarioInspector: cierre.comnetarioI,
      comentarioCliente:   cierre.comnetarioC,
      aclaracionInspector: cierre.aclaracionI,
      aclaracionCliente:   cierre.aclaracionC,
      firmaCliente:        cierre.firmaC,
      firmaInspector:      localStorage.getItem("firma") || "",
    };

    const url    = mode === "edit" ? api.reporteServicio + initialData.id : api.reporteServicio;
    const method = mode === "edit" ? "PUT" : "POST";

    try {
      setLoading(true);
      const res  = await fetch(url, {
        method,
        body: JSON.stringify(body),
        headers: { "Content-type": "application/json; charset=UTF-8", "iron-token": userToken },
      });
      const resData = await res.json();
      setLoading(false);
      if (res.ok) {
        playSuccess();
        await swal({
          title: mode === "edit" ? "Reporte actualizado!" : "Reporte creado!",
          icon: "success",
          timer: 2500,
        });
        onClose && onClose();
        navigate("/ReporteServicio");
      } else {
        swal("Error", resData.message || "Ocurrio un error inesperado.", "error");
      }
    } catch {
      setLoading(false);
      swal("Error", "Error de conexion. Contacta al administrador.", "error");
    }
  };

  if (loading) return <Loading />;
  const isView  = mode === "view";
  const isEdit  = mode === "edit";
  const isFlat  = isEdit || isView;   // Edit y view muestran todo a la vez

  const NavBar = () => (
    /*
     * position: sticky + top: 0 dentro del contenedor scrolleable.
     * Esta es la unica tecnica 100% confiable: el elemento vive
     * dentro del scroll container, se desplaza con el contenido
     * hasta llegar al tope (top:0) y ahi se "pega".
     */
    <Box sx={{
      position: "sticky",
      top: 0,
      zIndex: 10,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      px: { xs: 2, md: 3 },
      py: 1,
      bgcolor: "background.paper",
      borderTop: "1px solid",
      borderBottom: "1px solid",
      borderColor: "divider",
    }}>
      <Button variant="text" size="small" startIcon={<ArrowBackIcon />}
        onClick={retroceder} disabled={paso === 0} sx={{ color: "text.secondary" }}>
        Anterior
      </Button>
      <Typography variant="caption" color="text.secondary" fontWeight={600}>
        {paso + 1} / {STEPS.length} &mdash; {STEPS[paso]}
      </Typography>
      {paso < STEPS.length - 1 ? (
        <Button variant="contained" size="small" endIcon={<ArrowForwardIcon />} onClick={avanzar}
          sx={{ bgcolor: "#ED9519", "&:hover": { bgcolor: "#c97d0e" }, color: "#1a0e00", fontWeight: 700 }}>
          Siguiente
        </Button>
      ) : !isView ? (
        <Button variant="contained" size="small" color="success" endIcon={<SendIcon />} onClick={enviar} sx={{ fontWeight: 700 }}>
          {mode === "edit" ? "Guardar" : "Enviar"}
        </Button>
      ) : (
        <Button variant="outlined" size="small" onClick={onClose}>Cerrar</Button>
      )}
    </Box>
  );

  const detalleProps = {
    mode,
    handleConditionChange,
    selectedCondition,
    setSelectedCondition,
    firmaI:      cierre.firmaI,      setFirmaI:      v => handleCierre("firmaI", v),
    aclaracionI: cierre.aclaracionI, setAclaracionI: v => handleCierre("aclaracionI", v),
    firmaC:      cierre.firmaC,      setFirmaC:      v => handleCierre("firmaC", v),
    aclaracionC: cierre.aclaracionC, setAclaracionC: v => handleCierre("aclaracionC", v),
    comnetarioI: cierre.comnetarioI, setComnetarioI: v => handleCierre("comnetarioI", v),
    comnetarioC: cierre.comnetarioC, setComnetarioC: v => handleCierre("comnetarioC", v),
  };

  // ── Secciones reutilizables ────────────────────────────────────────────────
  const SeccionEquipo = () => (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" fontWeight={600} color="text.secondary" mb={1}
          textTransform="uppercase" letterSpacing={0.5}>Tipo de equipo</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          value={REPORTES.find(r => r.label === tipoReporte) || null}
          onChange={handleAutoComplete}
          options={REPORTES}
          disabled={isView}
          renderInput={params => <TextField {...params} label="Tipo de equipo" required size="small" />}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField label="Cliente" fullWidth required size="small"
          value={cliente} onChange={e => setCliente(e.target.value)} disabled={isView} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField label="Ubicacion del equipo" fullWidth required size="small"
          value={ubicacion} onChange={e => setUbicacion(e.target.value)} disabled={isView} />
      </Grid>
    </Grid>
  );

  const SeccionDatos = () => (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" fontWeight={600} color="text.secondary" mb={1}
          textTransform="uppercase" letterSpacing={0.5}>Datos del equipo</Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="modelo" label="Modelo" size="small" fullWidth
          value={datos.modelo} onChange={handleDatosChange} disabled={isView} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="chasis" label="N Chasis" size="small" fullWidth
          value={datos.chasis} onChange={handleDatosChange} disabled={isView} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="serie" label="N Serie" size="small" fullWidth required
          value={datos.serie} onChange={handleDatosChange} disabled={isView} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="horometro" label="Horometro" size="small" fullWidth required
          value={datos.horometro} onChange={handleDatosChange} disabled={isView} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="fecha" label="Fecha" type="date" size="small" fullWidth
          value={datos.fecha} onChange={handleDatosChange} disabled={isView}
          InputLabelProps={{ shrink: true }} />
      </Grid>
      <Grid item xs={12}><Divider sx={{ my: 1 }} /></Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle2" fontWeight={600} color="text.secondary" mb={1}
          textTransform="uppercase" letterSpacing={0.5}>Transmision</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField label="Tipo de transmision" select size="small" fullWidth required
          value={transmision} onChange={e => setTransmision(e.target.value)} disabled={isView}>
          <MenuItem value="M">T/C - Convertidor de torque</MenuItem>
          <MenuItem value="C">T/M - Transmision mecanica</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}><Divider sx={{ my: 1 }} /></Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle2" fontWeight={600} color="text.secondary" mb={1}
          textTransform="uppercase" letterSpacing={0.5}>Motor</Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="modeloMotor" label="Modelo motor" size="small" fullWidth
          value={datos.modeloMotor} onChange={handleDatosChange} disabled={isView} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="serieMotor" label="N Serie motor" size="small" fullWidth
          value={datos.serieMotor} onChange={handleDatosChange} disabled={isView} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="modeloMotor1" label="Modelo motor 2" size="small" fullWidth
          value={datos.modeloMotor1} onChange={handleDatosChange} disabled={isView} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField id="serieMotor1" label="N Serie motor 2" size="small" fullWidth
          value={datos.serieMotor1} onChange={handleDatosChange} disabled={isView} />
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ height: "100%", overflowY: "auto", display: "flex", flexDirection: "column" }}>

      {/* Titulo */}
      <Box sx={{ flexShrink: 0, px: { xs: 2, md: 3 }, pt: 2, pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1.5 }}>
          <Box>
            <Typography variant="h6" fontWeight={700}>
              {mode === "create" ? "Nuevo reporte de servicio" : mode === "edit" ? "Editar reporte" : "Ver reporte"}
            </Typography>
            {reporteElegido && <Typography variant="caption" color="text.secondary">{reporteElegido}</Typography>}
          </Box>
          {onClose && <IconButton onClick={onClose} size="small" sx={{ ml: 1 }}><CloseIcon /></IconButton>}
        </Box>
        {/* Stepper solo en modo create */}
        {!isFlat && (
          <Stepper activeStep={paso} alternativeLabel sx={{ mb: 1 }} StepIconComponent={StepIconCustom}>
            {STEPS.map(label => (
              <Step key={label}>
                <StepLabel sx={{
                  "& .MuiStepLabel-label": { fontSize: "0.7rem", fontWeight: 600 },
                  "& .MuiStepLabel-label.Mui-active": { color: "#ED9519" },
                  "& .MuiStepLabel-label.Mui-completed": { color: "#2E7D32" },
                }}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        )}
      </Box>

      {/* NavBar sticky solo en modo create */}
      {!isFlat && <NavBar />}

      {/* Contenido */}
      <Box sx={{ flex: 1, px: { xs: 2, md: 3 }, py: 2 }}>
        {isFlat ? (
          // ── MODO EDICIÓN/VISTA: todos los pasos a la vez ─────────────────────
          <>
            {SeccionEquipo()}
            <Divider sx={{ my: 3 }} />
            {SeccionDatos()}
            <Divider sx={{ my: 3 }} />
            <Detalle {...detalleProps} condiciones={condicionesServicio} />
            <Divider sx={{ my: 3 }} />
            <Detalle {...detalleProps} condiciones={[]} signatureOnly />
          </>
        ) : (
          // ── MODO CREATE: wizard paso a paso ──────────────────────────────────
          <>
            {paso === 0 && SeccionEquipo()}
            {paso === 1 && SeccionDatos()}
            {paso === 2 && <Detalle {...detalleProps} condiciones={condicionesServicio} />}
            {paso === 3 && <Detalle {...detalleProps} condiciones={[]} signatureOnly />}
          </>
        )}
      </Box>

      {/* Footer */}
      {isFlat ? (
        // ── Modo edición/vista: solo botón guardar/cerrar ─────────────────────
        <Box sx={{
          position: "sticky", bottom: 0, zIndex: 10,
          display: "flex", justifyContent: "flex-end", gap: 1,
          px: { xs: 2, md: 3 }, py: 1.5,
          bgcolor: "background.paper", borderTop: "1px solid", borderColor: "divider",
        }}>
          {onClose && <Button variant="outlined" onClick={onClose}>Cancelar</Button>}
          {!isView && (
            <Button variant="contained" color="success" endIcon={<SendIcon />} onClick={enviar} sx={{ fontWeight: 700 }}>
              Guardar cambios
            </Button>
          )}
          {isView && onClose && <Button variant="outlined" onClick={onClose}>Cerrar</Button>}
        </Box>
      ) : (
        // ── Modo create: anterior / siguiente / enviar ────────────────────────
        <Box sx={{
          position: "sticky", bottom: 0, zIndex: 10,
          display: "flex", justifyContent: "space-between", alignItems: "center",
          px: { xs: 2, md: 3 }, py: 1.5,
          bgcolor: "background.paper", borderTop: "1px solid", borderColor: "divider",
        }}>
          <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={retroceder} disabled={paso === 0}>
            Anterior
          </Button>
          <Typography variant="caption" color="text.secondary">{paso + 1} de {STEPS.length}</Typography>
          {paso < STEPS.length - 1 ? (
            <Button variant="contained" endIcon={<ArrowForwardIcon />} onClick={avanzar}
              sx={{ bgcolor: "#ED9519", "&:hover": { bgcolor: "#c97d0e" }, color: "#1a0e00", fontWeight: 700 }}>
              Siguiente
            </Button>
          ) : (
            <Button variant="contained" color="success" endIcon={<SendIcon />} onClick={enviar} sx={{ fontWeight: 700 }}>
              Enviar
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default NuevoReporteServicio;
